export const spacing = {
  xs: 4,
  sm: 6,
  md: 10,
  lg: 16,
  xl: 22,
  xxl: 32
};
